import React from "react";

import QueryResults from "components/Common/QueryResults";

// sorry, this is awkward. we thought 1:1 query:component, but
// we need 2 queries to get all our nps data
const NpsQueryResults = ({ npsId, children }) => {
  if (!npsId) {
    return children([]);
  }

  return (
    <QueryResults
      query={{
        metrics: ["nps_computed_score", "nps_respondents"],
        conditions: [["flow_id", "==", npsId]],
        start_time: "0 days ago"
      }}
    >
      {computedResults => {
        return (
          <QueryResults
            query={{
              metrics: [
                "nps_promoters",
                "nps_detractors",
                "nps_neutrals",
                "nps_feedbacks_submitted",
                "nps_survey_started"
              ],
              conditions: [["flow_id", "==", npsId]],
              start_time: "30 days ago"
            }}
          >
            {metricsResults => {
              if (
                !Array.isArray(computedResults) ||
                !computedResults.length ||
                !Array.isArray(metricsResults) ||
                !metricsResults.length
              ) {
                return children(null);
              }

              const {
                nps_computed_score: npsScore,
                nps_respondents: responseCount
              } = computedResults[0];

              const {
                nps_promoters: promoters,
                nps_detractors: detractors,
                nps_neutrals: neutrals,
                nps_feedbacks_submitted: qualitativeCount,
                nps_survey_started: shownCount
              } = metricsResults[0];

              return children({
                npsScore,
                responseCount,
                promoters,
                detractors,
                neutrals,
                qualitativeCount,
                shownCount
              });
            }}
          </QueryResults>
        );
      }}
    </QueryResults>
  );
};

export default NpsQueryResults;
